var map = {
	"./bot/bot.module": [
		"./src/app/bot/bot.module.ts",
		"default~bot-bot-module~botprocess-botprocess-module~process-process-module",
		"common",
		"bot-bot-module"
	],
	"./botprocess/botprocess.module": [
		"./src/app/botprocess/botprocess.module.ts",
		"default~bot-bot-module~botprocess-botprocess-module~process-process-module",
		"common",
		"botprocess-botprocess-module"
	],
	"./form/form.module": [
		"./src/app/form/form.module.ts"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"home-home-module"
	],
	"./list/list.module": [
		"./src/app/list/list.module.ts"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts",
		"login-login-module"
	],
	"./page/page.module": [
		"./src/app/page/page.module.ts",
		"page-page-module"
	],
	"./process/process.module": [
		"./src/app/process/process.module.ts",
		"default~bot-bot-module~botprocess-botprocess-module~process-process-module",
		"common",
		"process-process-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;